'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { Tag } from '../Tag';
import { IllustrationSize } from './types';
import { DeviceCardContainer, IconContainer, TopCircle, DeviceCardButton, Image, TopRow, BottomRow, PrimaryTextWrapper, TextWrapper, TagWrapper, CardWrapper, ArrowIconWrapper, AddRemoveWrapper, AddRemoveButton, AddRemoveCounter, AddRemoveTextWrapper, AddRemoveWrapperFixedHeight } from './elements';
import { colors } from '../../abstracts';
import { usePropDeprecation } from '../../util';
export const DeviceCard = ({
  id,
  className,
  disabled,
  selected,
  variant = 'default',
  iconSrc,
  imageSrc,
  primary,
  secondary,
  tertiary,
  tagText,
  tagType,
  /** 
  @deprecated buttonLabel is deprecated and will be removed in v3, please update to button prop.
  */
  buttonLabel,
  /** 
  @deprecated buttonVariant is deprecated and will be removed in v3, please update to button prop.
  */
  buttonVariant,
  button = {},
  counter,
  removeButton,
  addButton,
  size = 'sm',
  isFixedHeight = true,
  primaryTextClassName = '',
  ...rest
}) => {
  usePropDeprecation({
    name: 'buttonLabel',
    version: '3.0.0',
    alternative: 'button',
    value: buttonLabel
  });
  usePropDeprecation({
    name: 'buttonVariant',
    version: '3.0.0',
    alternative: 'button',
    value: buttonVariant
  });
  const {
    label: btnLabel = buttonLabel,
    variant: btnVariant = buttonVariant,
    ...deviceCardBtn
  } = button;
  let middleRow = /*#__PURE__*/React.createElement(React.Fragment, null, primary && /*#__PURE__*/React.createElement(PrimaryTextWrapper, {
    className: primaryTextClassName
  }, /*#__PURE__*/React.createElement(Text, {
    size: size === 'sm' ? 2 : 3
  }, primary)), secondary && /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(Text, {
    size: 1,
    color: disabled ? colors.disabledText : colors.neutralDeeper
  }, secondary)), tertiary && /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(Text, {
    size: 1,
    color: disabled ? colors.disabledText : colors.neutralDeeper
  }, tertiary)), tagText && /*#__PURE__*/React.createElement(TagWrapper, null, /*#__PURE__*/React.createElement(Tag, {
    text: tagText,
    type: disabled ? 'disabled' : tagType,
    size: "small"
  })));
  let topRow,
    bottomRow,
    cardType,
    cardElement = 'button';
  switch (variant) {
    case 'default':
      cardType = 'call-to-action';
      topRow = /*#__PURE__*/React.createElement(TopRow, null, iconSrc ? /*#__PURE__*/React.createElement(IconContainer, {
        $variant: variant
      }, /*#__PURE__*/React.createElement(Icon.Compat, {
        src: iconSrc,
        size: IllustrationSize
      })) : imageSrc ? /*#__PURE__*/React.createElement(Image, {
        src: imageSrc,
        role: "presentation",
        alt: "",
        $size: size
      }) : null, counter ? /*#__PURE__*/React.createElement(TopCircle, {
        $variant: variant,
        $disabled: disabled,
        className: "topCircle"
      }, counter) : null);
      bottomRow = btnLabel ? /*#__PURE__*/React.createElement(BottomRow, null, /*#__PURE__*/React.createElement(DeviceCardButton, _extends({}, deviceCardBtn, {
        disabled: disabled,
        size: "small",
        variant: btnVariant || 'default'
      }), btnLabel)) : null;
      break;
    case 'add-remove':
      cardElement = 'div';
      topRow = /*#__PURE__*/React.createElement(TopRow, null, iconSrc && /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(Icon.Compat, {
        src: iconSrc,
        size: IllustrationSize
      })));
      middleRow = isFixedHeight ? null : /*#__PURE__*/React.createElement(AddRemoveTextWrapper, {
        $size: size
      }, middleRow);
      bottomRow = isFixedHeight ? /*#__PURE__*/React.createElement(AddRemoveWrapperFixedHeight, null, /*#__PURE__*/React.createElement(AddRemoveButton, _extends({}, removeButton, {
        iconSrc: "minus-delete",
        disabled: disabled,
        ariaLabel: (removeButton === null || removeButton === void 0 ? void 0 : removeButton.ariaLabel) ?? 'minus'
      })), /*#__PURE__*/React.createElement(AddRemoveCounter, {
        $variant: variant,
        "aria-live": "polite"
      }, counter), /*#__PURE__*/React.createElement(AddRemoveButton, _extends({}, addButton, {
        iconSrc: "plus-add",
        disabled: disabled,
        ariaLabel: (addButton === null || addButton === void 0 ? void 0 : addButton.ariaLabel) ?? 'plus'
      }))) : /*#__PURE__*/React.createElement(AddRemoveWrapper, null, /*#__PURE__*/React.createElement(AddRemoveButton, _extends({}, removeButton, {
        iconSrc: "minus-delete",
        disabled: disabled,
        ariaLabel: (removeButton === null || removeButton === void 0 ? void 0 : removeButton.ariaLabel) ?? 'minus'
      })), /*#__PURE__*/React.createElement(AddRemoveCounter, {
        $variant: variant,
        "aria-live": "polite"
      }, counter), /*#__PURE__*/React.createElement(AddRemoveButton, _extends({}, addButton, {
        iconSrc: "plus-add",
        disabled: disabled,
        ariaLabel: (addButton === null || addButton === void 0 ? void 0 : addButton.ariaLabel) ?? 'plus'
      })));
      break;
    case 'empty-default':
      cardType = 'call-to-action';
      topRow = /*#__PURE__*/React.createElement(TopRow, null, iconSrc && /*#__PURE__*/React.createElement(IconContainer, {
        $variant: variant
      }, /*#__PURE__*/React.createElement(Icon.Compat, {
        src: iconSrc,
        size: IllustrationSize,
        fill: colors.neutralBright
      })), /*#__PURE__*/React.createElement(TopCircle, {
        $variant: variant,
        $disabled: disabled
      }, /*#__PURE__*/React.createElement(Icon.Compat, {
        src: "plus-add",
        ariaLabel: "Add"
      })));
      middleRow = primary ? /*#__PURE__*/React.createElement(PrimaryTextWrapper, {
        className: primaryTextClassName
      }, /*#__PURE__*/React.createElement(Text, {
        size: 2
      }, primary)) : null;
      break;
    case 'empty-devices':
      cardType = 'call-to-action';
      topRow = /*#__PURE__*/React.createElement(TopRow, null, /*#__PURE__*/React.createElement(IconContainer, {
        $variant: variant
      }, /*#__PURE__*/React.createElement(Icon.Compat, {
        src: iconSrc || 'add-other-device',
        size: IllustrationSize,
        fill: colors.neutralBright
      })), /*#__PURE__*/React.createElement(TopCircle, {
        $variant: variant,
        $disabled: disabled
      }, /*#__PURE__*/React.createElement(Icon.Compat, {
        src: "plus-add"
      })));
      middleRow = /*#__PURE__*/React.createElement(PrimaryTextWrapper, {
        className: primaryTextClassName
      }, /*#__PURE__*/React.createElement(Text, {
        size: 2
      }, primary || 'Add other device', /*#__PURE__*/React.createElement(ArrowIconWrapper, {
        $disabled: disabled
      }, /*#__PURE__*/React.createElement(Icon.Compat, {
        src: "arrow-right",
        size: "14px"
      }))));
      break;
  }
  return /*#__PURE__*/React.createElement(CardWrapper, _extends({
    id: id,
    className: className,
    disabled: disabled,
    selected: selected,
    isFixedHeight: isFixedHeight,
    type: cardType,
    element: cardElement,
    $variant: variant,
    $size: size
  }, rest, {
    "data-aui": "device-card"
  }), /*#__PURE__*/React.createElement(DeviceCardContainer, null, topRow, middleRow, bottomRow));
};